import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecargaPontualShopWindowComponent } from './recarga-pontual-shop-window.component';
import { MatDividerModule } from '@angular/material/divider';
import { CarouselSwiperModule } from 'src/app/shared/components/carousel-swiper/carousel-swiper.module';
import { PaymentMethodsModule } from 'src/app/shared/components/payment-methods/payment-methods.module';
import { PriceTableModule } from 'src/app/shared/components/price-table/price-table.module';
import { ProductConsultaModule } from 'src/app/shared/components/product-consulta/product-consulta.module';
import { WindowShopManagerHeaderModule } from 'src/app/shared/components/window-shop-manager-header/window-shop-manager-header.module';
import { WindowShopManagerNutritionTableModule } from 'src/app/shared/components/window-shop-manager-nutrition-table/window-shop-manager-nutrition-table.module';
import { ProductAssinaturaModule } from 'src/app/shared/components/product-assinatura/product-assinatura.module';



@NgModule({
  declarations: [RecargaPontualShopWindowComponent],
  imports: [
    CommonModule,
    WindowShopManagerHeaderModule,
    WindowShopManagerNutritionTableModule,
    PriceTableModule,
    CarouselSwiperModule,
    ProductAssinaturaModule,
    
    PaymentMethodsModule,
    MatDividerModule
  ],
  exports: [RecargaPontualShopWindowComponent]
})
export class RecargaPontualShopWindowModule { }
